<template>
  <div class="TableHead">
    <div class="query">
      <TableTabs v-if="hasResults && hasTabs" :pagination="pagination" />
      <Btn
        v-if="hasFilters"
        class="filtersToggle sm"
        @click="doShowFilters = !doShowFilters">
        <Icon :name="doShowFilters ? 'up' : 'down'" />
        {{ doShowFilters ? this.$t('hide') : this.$t('show') }} {{ $t('filters') }}
      </Btn>
    </div>

    <transition appear name="slide-down">
      <TableFilters v-if="hasFilters && doShowFilters" :pagination="pagination" />
    </transition>

    <TableColumns
      v-if="hasColumns"
      :pagination="pagination" />
  </div>
</template>

<script>
import TableColumns from './TableColumns'
import TableFilters from './TableFilters'
import TableTabs from './TableTabs'

export default {
  components: {
    TableColumns,
    TableFilters,
    TableTabs,
  },
  props: {
    hasResults: Boolean,
    pagination: Object,
  },
  data() {
    return {
      doShowFilters: false,
    }
  },
  computed: {
    hasTabs() {
      return !!this.pagination.tabs.length
    },
    hasFilters() {
      return !!this.pagination.filters.length
    },
    hasColumns() {
      return !!this.pagination.dataColumns.length
    },
  },
}
</script>

<style lang="scss">
.TableHead {
  background: $white-bis;
  display: none;
  padding: 0 $grid-unit;
  @include md {
    display: block;
  }

  > .query {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    margin-bottom: 0.5rem;

    > .filtersToggle {
      height: fit-content;
      width: auto;
    }
  }

  .TableFilters {
    margin-bottom: 0.5rem;
  }
}
</style>

<i18n>
{
  "en": {
    "filters": "filters",
    "show": "Show",
    "hide": "Hide"
  }
}
</i18n>
